const config = {
//  BASE_URL: "http://localhost:5000",
 BASE_URL: "https://api.bentexonline.online",
 FRONT_URL: "https://bentexonline.online",
  //  FRONT_URL: "http://localhost:3000",
}
export default config;

// AddCustomer
// customer details
// OrdersPage